export enum Domain {
  KITAHUB,
  PIXELWERKSTATT,
  MEDIENECKE,
}
